import React from "react";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  ListGroupItem,
  ListGroup,
  Container,
  Row,
  Col,
} from "reactstrap";

import "../../utils/lang/i18n";
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footer/Footer.js";

import bigChartData from "variables/charts.js";

export default function LandingPage() {
  const { t, i18n } = useTranslation();
  React.useEffect(() => {
    document.body.classList.toggle("landing-page");
    // Specify how to clean up after this effect:
    return function cleanup() {
      document.body.classList.toggle("landing-page");
    };
  }, []);
  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <div className="page-header">
          <img
            alt="..."
            className="path"
            src={require("assets/img/blob.png")}
          />
          <img
            alt="..."
            className="path2"
            src={require("assets/img/path2.png")}
          />
          <img
            alt="..."
            className="shapes triangle"
            src={require("assets/img/triunghiuri.png")}
          />
          <img
            alt="..."
            className="shapes wave"
            src={require("assets/img/waves.png")}
          />
          <img
            alt="..."
            className="shapes squares"
            src={require("assets/img/patrat.png")}
          />
          <img
            alt="..."
            className="shapes circle"
            src={require("assets/img/cercuri.png")}
          />
          <div className="content-center">
            <Row className="row-grid justify-content-between align-items-center text-left">
              <Col lg="6" md="6">
                <h1 className="text-white">
                  <Trans>Confessing Jesus</Trans> <br />
                  <span className="text-white"><Trans>as Lord and Savior of your life!</Trans></span>
                </h1>
                <p className="text-white mb-3">
                <Trans>The Bible says there is only one way to heaven, as Jesus said, “I am the way and the truth and the life. No one comes to the Father except through me.”</Trans> <a target="_blank" href="https://www.bible.com/pt/bible/1840/jhn.14.6"><Trans>(John 14:6)</Trans></a>, <Trans>and that is to accept the gospel (good news) of Jesus Christ.</Trans>
                </p>
                <p className="text-white mb-3">
                <Trans>Good works cannot save you during the reckoning—only faith in Jesus can. </Trans>
                <Trans>“For it is by grace you have been saved, through faith—and this is not from yourselves, it is the gift of God— not by works, so that no one can boast.”</Trans> <a target="_blank" href="https://www.bible.com/pt/bible/1840/eph.2.8-9"><Trans>(Ephesians 2:8-9)</Trans></a>.
                </p>
              </Col>
              <Col className="px-4" lg="4" md="5">
                <img
                  alt="..."
                  className="img-confesse"
                  src={require("assets/img/confesse-jesus-biblia.png")}
                />
              </Col>
            </Row>
          </div>
        </div>
        <section className="section section-lg confesse-page">
          <section className="section">
            <img
              alt="..."
              className="path"
              src={require("assets/img/path4.png")}
            />
            <Container>
            <Row className="justify-content-between">
              <Col md="6">
                <Row className="px-4 justify-content-between align-items-center">
                <img
                  alt="..."
                  className="img-confie"
                  src={require("assets/img/confie-em-jesus.png")}
                />                  
                </Row>
              </Col>
              <Col md="5">
                <h1 className="confesse-title text-left"><Trans>Trust in Jesus</Trans></h1>
                <h5 className="text-on-back">01</h5>
                <p className="confesse-description text-left">
                <Trans>Trust in Jesus Christ! Here's what you should do.</Trans>
                </p>
              </Col>
            </Row>
          </Container>
          </section>
        </section>
        <section className="section section-lg confesse-page">
          <img
            alt="..."
            className="path"
            src={require("assets/img/path4.png")}
          />
          <img
            alt="..."
            className="path2"
            src={require("assets/img/path5.png")}
          />
          <img
            alt="..."
            className="path3"
            src={require("assets/img/path2.png")}
          />
                     <Container>
            <Row className="justify-content-between">
              <Col md="5">
              <h1 className="confesse-title text-left"><Trans>Admit you</Trans> <br/><Trans>are a sinner</Trans>e</h1>
                <h5 className="text-on-back">02</h5>
                <ul className="list-unstyled mt-5">
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5>"<Trans>for all have sinned and fall short of the glory of God</Trans>" <a href="https://www.bible.com/pt/bible/1840/rom.3.23" target="_blank">(<Trans>Romans</Trans> 3:23)</a>.</h5>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>
                        <div className="ml-3">
                          <h5>"<Trans>Therefore, just as sin entered the world through one man, and death through sin, and in this way death came to all people, because all sinned</Trans>" <a target="_blank" href="https://www.bible.com/pt/bible/1840/rom.5.12">(<Trans>Romans</Trans> 5:12)</a>.</h5>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>
                        <div className="ml-3">
                          <h5>"<Trans>If we claim we have not sinned, we make him out to be a liar and his word is not in us</Trans>" <a href="https://www.bible.com/pt/bible/1840/1jn.1.10" target="_blank">(1 <Trans>John</Trans> 1:10)</a>.</h5>
                        </div>
                      </div>
                    </li>
                  </ul>
              </Col>
              <Col md="6">
              <Row className="px-4 justify-content-between align-items-center">
                <img
                  alt="..."
                  className="img-confie"
                  src={require("assets/img/admita-que-e-pecador.png")}
                />                  
                </Row>              
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section section-lg confesse-page">
          <section className="section">
            <img
              alt="..."
              className="path"
              src={require("assets/img/path4.png")}
            />
            <Container>
            <Row className="justify-content-between">
              <Col md="6">
                <Row className="px-4 justify-content-between align-items-center">
                <img
                  alt="..."
                  className="img-confie"
                  src={require("assets/img/mudar-sua-mente.png")}
                />                  
                </Row>
              </Col>
              <Col md="5">
                <h1 className="confesse-title text-left"><Trans>Change your mindset</Trans></h1>
                <h5 className="text-on-back">03</h5>
                <p className="confesse-description text-left">                
                <Trans>Be willing to change your mind; turn from sin, repent.</Trans>
                </p>
                <ul className="list-unstyled mt-5">
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5><Trans>Jesus said:</Trans> "<Trans>I tell you, no! But unless you repent, you too will all perish.</Trans>" (<Trans>Luke</Trans> 13:5).</h5>
                        </div>
                      </div>
                    </li>
                </ul>
              </Col>
            </Row>
          </Container>
          </section>
        </section>  
        <section className="section section-lg confesse-page">
          <img
            alt="..."
            className="path"
            src={require("assets/img/path4.png")}
          />
          <img
            alt="..."
            className="path2"
            src={require("assets/img/path5.png")}
          />

                     <Container>
            <Row className="justify-content-between">
              <Col md="5">
              <h1 className="confesse-title text-left"><Trans>Believe in Jesus</Trans></h1>
                <h5 className="text-on-back">04</h5>
                <p><Trans>Believe that Jesus Christ died for you, was buried, and rose from the dead.</Trans></p>
                <ul className="list-unstyled mt-5">
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5>"<Trans>For God so loved the world that he gave his one and only Son, that whoever believes in him shall not perish but have eternal life.</Trans>" (<Trans>John</Trans> 3:16).</h5>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>
                        <div className="ml-3">
                          <h5>"<Trans>But God demonstrates his own love for us in this: While we were still sinners, Christ died for us.</Trans>" (<Trans>Romans</Trans> 5:8).</h5>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>
                        <div className="ml-3">
                          <h5>"<Trans>If you declare with your mouth, “Jesus is Lord,” and believe in your heart that God raised him from the dead, you will be saved.</Trans>" (<Trans>Romans</Trans> 10:9).</h5>
                        </div>
                      </div>
                    </li>
                  </ul>
              </Col>
              <Col md="6">
              <Row className="justify-content-between align-items-center">
                <img
                  alt="..."
                  className="img-confie"
                  src={require("assets/img/" + t("he-live.png"))}
                />                  
                </Row>              
              </Col>
            </Row>
          </Container>
        </section>      
        <section className="section section-lg confesse-page">
          <section className="section">
            <img
              alt="..."
              className="path"
              src={require("assets/img/path4.png")}
            />
            <Container>
            <Row className="justify-content-between">
              <Col md="6">
                <Row className="px-4 justify-content-between align-items-center">
                <img
                  alt="..."
                  className="img-confie"
                  src={require("assets/img/ore.png")}
                />                  
                </Row>
              </Col>
              <Col md="5">
                <h1 className="confesse-title text-left">Ore</h1>
                <h5 className="text-on-back">05</h5>
                <p className="confesse-description text-left">
                Através de oração, chame Jesus até sua vida para se tornar o seu salvador.
                </p>
                <ul className="list-unstyled mt-5">
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5>"Visto que com o coração se crê para a justiça e com a boca se faz confissão para a salvação" (Romanos 10:10).</h5>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5>"Porque todo aquele que invocar o nome do Senhor será salvo" (Romanos 10:13).</h5>
                        </div>
                      </div>
                    </li>                    
                </ul>
                <h4>Faça essa oração:</h4>
                <p>Querido Deus, eu sou um pecador e preciso de perdão. Eu acredito que Jesus Cristo derramou seu precioso sangue e morreu pelos meus pecados. Eu estou disposto a mudar e abandonar o pecado. Eu agora convido Jesus para fazer parte de minha vida como meu senhor e salvador.</p>
                <ul className="list-unstyled mt-5">
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5>"Mas, a todos quantos o receberam, deu-lhes o poder de serem feitos filhos de Deus, aos que creem no seu nome" (João 1:12).</h5>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5>"Assim que, se alguém está em Cristo, nova criatura é; as coisas velhas já passaram; eis que tudo se fez novo" (2 Coríntios 5:17).</h5>
                        </div>
                      </div>
                    </li>                    
                </ul>                
              </Col>
            </Row>
          </Container>
          </section>
        
        </section>   
        <div
          className="section section-download"
          data-background-color="black"
          id="download-section"
        >
          <Container>
            <Row className="justify-content-md-center">
              <Col className="text-center" lg="8" md="12">
                <h3 className="description">
                Se você recebeu Jesus Cristo como senhor e salvador, como um cristão...
                </h3>
              </Col>
            </Row>
          </Container>
        </div>   
        <section className="section section-lg confesse-page">
          <img
            alt="..."
            className="path"
            src={require("assets/img/path4.png")}
          />

                     <Container>
            <Row className="justify-content-between">
              <Col md="5">
              <h1 className="confesse-title text-left">Leia a Bíblia</h1>
                <h5 className="text-on-back">06</h5>
                <p><strong>Leia a Bíblia todos os dias para poder conhecer melhor a Cristo.</strong> Leia a Bíblia Sagrada, o guia e instrumento para a bondade, o caminho certo para a vida eterna (se tiver dúvidas, procure saciá-las com sua fé, aprendendo e sendo determinado — nunca hesitando).</p>
                <ul className="list-unstyled mt-5">
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5>"Procura apresentar-te a Deus aprovado, como obreiro que não tem de que se envergonhar, que maneja bem a palavra da verdade" (2 Timóteo 2:15).</h5>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>
                        <div className="ml-3">
                          <h5>"Lâmpada para os meus pés é tua palavra, e luz para o meu caminho" (Salmos 119:105).</h5>
                        </div>
                      </div>
                    </li>
                  </ul>
              </Col>
              <Col md="6">
              <Row className="justify-content-between align-items-center">
                <img
                  alt="..."
                  width={30}
                  className="img-confie"
                  src={require("assets/img/leia-a-biblia.png")}
                />                  
                </Row>              
              </Col>
            </Row>
          </Container>
        </section>   
        <section className="section section-lg confesse-page">
          <section className="section">
            <img
              alt="..."
              className="path"
              src={require("assets/img/path4.png")}
            />
            <Container>
            <Row className="justify-content-between">
              <Col md="6">
                <Row className="justify-content-between align-items-center">
                <img
                  alt="..."
                  className="img-confie"
                  src={require("assets/img/fale-com-Deus.png")}
                />                  
                </Row>
              </Col>
              <Col md="5">
                <h1 className="confesse-title text-left">Fale com Deus</h1>
                <h5 className="text-on-back">07</h5>
                <p className="confesse-description text-left">
                Fale com Deus em oração todos os dias.
                </p>
                <ul className="list-unstyled mt-5">
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5>"E, tudo o que pedirdes em oração, crendo, o recebereis" (Mateus 21:22).</h5>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5>"Não estejais inquietos por coisa alguma; antes as vossas petições sejam em tudo conhecidas diante de Deus pela oração e súplica, com ação de graças" (Filipenses 4:6).</h5>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5>"Mas nem todos têm obedecido ao evangelho; pois Isaías diz: Senhor, quem creu na nossa pregação? 17 De sorte que a fé é pelo ouvir, e o ouvir pela palavra de Deus. 18 Mas digo: Porventura não ouviram? Sim, por certo, pois Por toda a terra saiu a voz deles, E as suas palavras até aos confins do mundo" (Romanos 10:16-18).</h5>
                        </div>
                      </div>
                    </li>                                        
                </ul>
              </Col>
            </Row>
          </Container>
          </section>
        </section>   
        <section className="section section-lg confesse-page">
          <img
            alt="..."
            className="path"
            src={require("assets/img/path4.png")}
          />      

          <Container>
            <Row className="justify-content-between">
              <Col md="5">
              <h1 className="confesse-title text-left">Encontre uma igreja</h1>
                <h5 className="text-on-back">08</h5>
                <p>Procure uma igreja para poder ser batizado e entrar em comunhão com outros cristãos, adorando e servindo a Deus em conjunto; procure por uma igreja que usa a Bíblia como autoridade final.</p>
                <p>Caso queira ser membro da Conectados <Button
                  className="btn-round"
                  color="info"
                  href="/seja-membro"
                  role="button"
               
                >
                  Clique aqui
                </Button></p>
                <ul className="list-unstyled mt-5">
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5>"Portanto ide, fazei discípulos de todas as nações, batizando-os em nome do Pai, e do Filho, e do Espírito Santo" (Mateus 28:19).</h5>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>
                        <div className="ml-3">
                          <h5>"Não deixando a nossa congregação, como é costume de alguns, antes admoestando-nos uns aos outros; e tanto mais, quanto vedes que se vai aproximando aquele dia" (Hebreus 10:25).</h5>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>
                        <div className="ml-3">
                          <h5>"Toda a Escritura é divinamente inspirada, e proveitosa para ensinar, para redarguir, para corrigir, para instruir em justiça" (2 Timóteo 3:16).</h5>
                        </div>
                      </div>
                    </li>                    
                  </ul>
              </Col>
              <Col md="6">
              <Row className="justify-content-between align-items-center">
                <img
                  alt="..."
                  width={30}
                  className="img-confie"
                  src={require("assets/img/igreja.png")}
                />                  
                </Row>              
              </Col>
            </Row>
          </Container>
        </section>  
        <section className="section section-lg confesse-page">
          <section className="section">
            <img
              alt="..."
              className="path"
              src={require("assets/img/path4.png")}
            />
            <Container>
            <Row className="justify-content-between">
              <Col md="6">
                <Row className="justify-content-between align-items-center">
                <img
                  alt="..."
                  className="img-confie"
                  src={require("assets/img/fale-de-Cristo.png")}
                />                  
                </Row>
              </Col>
              <Col md="5">
                <h1 className="confesse-title text-left">Fale de Deus</h1>
                <h5 className="text-on-back">09</h5>
                <p className="confesse-description text-left">
                Fale para os outros sobre Cristo.
                </p>
                <ul className="list-unstyled mt-5">
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5>"E disse-lhes: Ide por todo o mundo, pregai o evangelho a toda criatura" (Marcos 16:15).</h5>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5>"Porque, se anuncio o evangelho, não tenho de que me gloriar, pois me é imposta essa obrigação; e ai de mim se não anunciar o evangelho!" (1 Coríntios 9:16).</h5>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                      <div className="icon icon-success mb-2">
                          <i className="tim-icons icon-tap-02" />
                        </div>

                        <div className="ml-3">
                          <h5>"Porque não me envergonho do evangelho de Cristo, pois é o poder de Deus para salvação de todo aquele que crê; primeiro do judeu, e também do grego" (Romanos 1:16).</h5>
                        </div>
                      </div>
                    </li>                                        
                </ul>
              </Col>
            </Row>
          </Container>
          </section>
        </section>                                           
        <Footer />
      </div>
    </>
  );
}
